import React, { useCallback, useEffect, useState } from "react";
import { adminApi } from "../services/adminApi";
import usePolling from "../hooks/usePolling";
import Pagination from "../components/Pagination";

export default function StakeManagement() {
  const [filters, setFilters] = useState({ userName: "", from: "", to: "" });
  const [data, setData] = useState({ items: [], summary: {}, total: 0, page: 1, pageSize: 10 });
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      const next = await adminApi.getStakes({
        page: data.page,
        pageSize: data.pageSize,
        ...filters,
      });
      setData(next);
      setError("");
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to load stake data");
    }
  }, [filters, data.page, data.pageSize]);

  usePolling(load, 20000, [
    filters.userName,
    filters.from,
    filters.to,
    data.page,
    data.pageSize,
  ]);

  useEffect(() => {
    setData((prev) => (prev.page === 1 ? prev : { ...prev, page: 1 }));
  }, [filters.userName, filters.from, filters.to]);

  return (
    <div>
      <h2>Stake Management</h2>
      <div className="row" style={{ marginBottom: 12 }}>
        <input
          placeholder="User name/email"
          value={filters.userName}
          onChange={(e) => setFilters((p) => ({ ...p, userName: e.target.value }))}
        />
        <input type="date" value={filters.from} onChange={(e) => setFilters((p) => ({ ...p, from: e.target.value }))} />
        <input type="date" value={filters.to} onChange={(e) => setFilters((p) => ({ ...p, to: e.target.value }))} />
        <button className="btn-primary" onClick={load}>Refresh</button>
      </div>
      {error ? <div className="error">{error}</div> : null}

      <div className="row" style={{ marginBottom: 12 }}>
        <div className="card">Total Staked: {(data.summary?.totalStakedAmount || 0).toFixed(2)}</div>
        <div className="card">Staking Earnings: {(data.summary?.totalStakingEarnings || 0).toFixed(2)}</div>
        <div className="card">Active Stakes: {data.summary?.activeStakes || 0}</div>
        <div className="card">Inactive Stakes: {data.summary?.inactiveStakes || 0}</div>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Plan</th>
                <th>Staked</th>
                <th>Profit</th>
                <th>Status</th>
                <th>Start Date</th>
                <th>End Date</th>
              </tr>
            </thead>
            <tbody>
              {data.items?.map((item) => (
                <tr key={item.id}>
                  <td>{item.user?.email || item.userId}</td>
                  <td>{item.plan?.name || "-"}</td>
                  <td>{item.stakedAmount}</td>
                  <td>{item.accumulatedProfit || 0}</td>
                  <td>{item.status}</td>
                  <td>{new Date(item.startDate).toLocaleDateString()}</td>
                  <td>{new Date(item.endDate).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          page={data.page}
          pageSize={data.pageSize}
          total={data.total}
          onPageChange={(nextPage) =>
            setData((prev) => ({
              ...prev,
              page: nextPage,
            }))
          }
        />
      </div>
    </div>
  );
}
